import { config } from '../config';

/** Returns an error message or null if the file is an acceptable PNG. */
export function validatePngFile(file: File): string | null {
  if (file.type !== 'image/png') {
    return 'Nur PNG-Dateien (image/png) sind erlaubt.';
  }
  if (file.size <= 0) {
    return 'Die Datei ist leer.';
  }
  if (file.size > config.maxSignatureBytes) {
    const mb = Math.round(config.maxSignatureBytes / (1024 * 1024));
    return `Datei zu groß (max. ${mb} MB).`;
  }
  return null;
}

/** Temporary object URL for in-memory preview; never persist. */
export function blobToObjectUrl(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function revokeObjectUrl(url: string | null | undefined): void {
  if (url) URL.revokeObjectURL(url);
}
